import { Component, ChangeDetectionStrategy, Output, EventEmitter, Input } from '@angular/core';

import {
  DataActionCardInfoType, DataActionFailedType
} from '@design-system/components/templates/data-action-card/entities/data-action-card.types';
import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';

@Component({
  selector: 'app-new-billing-data',
  templateUrl: './new-billing-data.component.html',
  styleUrls: ['./new-billing-data.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class NewBillingDataComponent {

  @Input() showError: boolean;
  @Input() isDisabled: boolean;
  @Input() isModal: boolean;
  @Input() icon: Icon;

  @Output() toggleList: EventEmitter<void> = new EventEmitter();

  public readonly dataActionCardInfoType = DataActionCardInfoType;
  public readonly dataActionFailedType = DataActionFailedType;

  public readonly icons = Icon;

  constructor() { }

  public clickEvent(): void {
    if (!this.isDisabled) this.toggleList.emit();
  }

}
